import { TbDeviceMobile, TbBuildingBank, TbWallet } from "react-icons/tb";
import { FlowEntryCard } from "../shared/FlowEntryCard";
import { CustomComingSoonCard } from "../ui/CustomComingSoonCard/CustomComingSoonCard";
import { PAYOUT_ACCOUNT_TYPES } from "./config/fundsTransferConfig";
import useFundsTransferStore from "../../stores/fundsTransferStore";

const WITHDRAWAL_OPTIONS = [
  {
    Icon: TbDeviceMobile,
    title: "Mobile Money",
    description: "Withdraw funds directly to your mobile money account.",
    path: "/funds-transfer/mobile-money",
    withdrawalType: PAYOUT_ACCOUNT_TYPES.MOBILE_MONEY,
  },
  {
    Icon: TbBuildingBank,
    title: "Bank",
    description: "Transfer funds to your linked bank account.",
    path: "/funds-transfer/bank",
    withdrawalType: PAYOUT_ACCOUNT_TYPES.BANK,
  },
  {
    Icon: TbWallet,
    title: "Paykit",
    description: "Withdraw directly from your Paykit wallet balance.",
    path: "/funds-transfer/paykit",
    withdrawalType: PAYOUT_ACCOUNT_TYPES.WALLET,
    comingSoon: true,
  },
];

export function FundsTransferContent({ isBlocked = false }) {
  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-6 mt-2">
      {WITHDRAWAL_OPTIONS.map(
        ({ Icon, title, description, path, withdrawalType, comingSoon }) => {
          if (comingSoon) {
            return (
              <CustomComingSoonCard key={path}>
                <FlowEntryCard
                  Icon={Icon}
                  title={title}
                  description={description}
                  path={path}
                  isBlocked={false}
                  onGetStarted={() => {}}
                />
              </CustomComingSoonCard>
            );
          }
          return (
            <FlowEntryCard
              key={path}
              Icon={Icon}
              title={title}
              description={description}
              path={path}
              isBlocked={isBlocked}
              onGetStarted={() => {
                const { reset, setPayoutAccountType, activateFlow } =
                  useFundsTransferStore.getState();
                reset();
                setPayoutAccountType(withdrawalType);
                activateFlow();
              }}
            />
          );
        },
      )}
    </div>
  );
}
